import { Injectable } from '@angular/core';
import { VariableTypeEnum } from '../../../../shared/ontology/variable-type.enum';
import { MapItem } from '../experiment-design.service';

@Injectable({ providedIn: 'root' })
export class ImportDesignContext {
    unmappedItems: MapItem[];
    variableTypeIds: VariableTypeEnum[] = [];
    excludedVariableIds: number[];
    importedData: any[];
    designSource: string;
}
